/* eslint-disable react/destructuring-assignment */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { mergeQueryString } from 'bernie-core';
import { withRouter } from 'react-router-dom';
import { UitkMenu, UitkMenuContainer, UitkMenuList, UitkMenuTrigger } from 'uitk-react-menu';
import { UitkTertiaryButton } from 'uitk-react-button';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
var HeaderLanguagesToolbarWithRouter = /** @class */ (function (_super) {
    __extends(HeaderLanguagesToolbarWithRouter, _super);
    function HeaderLanguagesToolbarWithRouter(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isOpen: false
        };
        _this.toggleMenu = _this.toggleMenu.bind(_this);
        return _this;
    }
    HeaderLanguagesToolbarWithRouter.prototype.toggleMenu = function () {
        var isOpen = this.state.isOpen;
        this.setState({
            isOpen: !isOpen
        });
    };
    HeaderLanguagesToolbarWithRouter.prototype._url = function (langId) {
        var location = this.props.location;
        var queryParams = {
            langid: langId
        };
        var queryString = mergeQueryString(location.search, queryParams);
        return location.pathname + "?" + queryString;
    };
    HeaderLanguagesToolbarWithRouter.prototype.render = function () {
        var _this = this;
        var languages = this.props.languages;
        if (!languages
            || !languages.alternativeLanguages
            || !languages.currentLanguage) {
            return null;
        }
        var alternativeLanguages = languages.alternativeLanguages, currentLanguage = languages.currentLanguage;
        if (alternativeLanguages.length > 1) {
            var languageItems = alternativeLanguages.map(function (language) { return ({
                className: 'uitk-list-item',
                label: language.displayLanguage,
                href: _this._url(language.langId),
                typeAnchor: true,
                attributes: {
                    role: 'menuItem',
                    tabindex: 0
                }
            }); });
            return (React.createElement("div", { className: "languageLinkItems" },
                React.createElement(UitkMenu, { isOpen: this.state.isOpen, onTriggerClick: this.toggleMenu },
                    React.createElement(UitkMenuTrigger, null,
                        React.createElement(UitkTertiaryButton, { className: "global-navigation-nav-button" },
                            React.createElement(UitkIcon, { name: "expand_more", size: UitkIconSize.SMALL }),
                            currentLanguage.displayLanguage)),
                    React.createElement(UitkMenuContainer, null,
                        React.createElement(UitkMenuList, { items: languageItems })))));
        }
        return alternativeLanguages.map(function (language) { return (React.createElement(UitkSpacing, { padding: { block: 'three', inlineend: 'four' }, key: "lang-" + language.langId + "-div" },
            React.createElement("div", { className: "header-links__item" },
                React.createElement("a", { role: "menuitem", tabIndex: 0, key: language.langId, href: _this._url(language.langId), rel: "nofollow" }, language.displayLanguage)))); });
    };
    return HeaderLanguagesToolbarWithRouter;
}(React.Component));
export var HeaderLanguagesToolbar = withRouter(HeaderLanguagesToolbarWithRouter);
//# sourceMappingURL=header-language-toolbar.js.map